import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import { sumWithoutGroupTotal, totalRowRatio } from '../../../../../react-table/helpers/rowTotals';
import UserTypes from '../../../../../common/redux/actions/types/UserTypes';

let replacedDate;
export const getDetailsTabNavOptions = receptaclePodPerformanceData => (rowInfo, index) => {
  if (index > 0) {
    const date = rowInfo.original.eventDate[index];
    replacedDate = date.toString().replace('/', ' ');
  }
  const currentDatetime = new Date(replacedDate);
  const formattedDate = `${currentDatetime.getFullYear()}-${currentDatetime.getMonth() + 1}-${currentDatetime.getDate()}`;
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.RECEPTACLE_POD_PERFORMANCE_404_DETAILS.id,
    mainReportId: ReportDefinitions.RECEPTACLE_POD_PERFORMANCE_404_SUMMARY.id,
    requestParams: {
      impc: rowInfo.row.impc,
      period: {
        from: index === 0 ? receptaclePodPerformanceData.period.from : formattedDate,
        to: index === 0 ? receptaclePodPerformanceData.period.to : formattedDate,
      },
      dateField: 'EVENT_DATE',
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
};

export const getConditionalProps = userType => (state, rowInfo) => {
  const className = userType !== UserTypes.IPC && rowInfo && rowInfo.original.ownImpc ? 'bg-blue-spindle' : '';
  return { className };
};

export default (data, userType, receptaclePodPerformanceData) => {
  const {
    MultilineColumn,
    MultilineDateColumn,
    MultilinePercentageColumn,
    NonZeroNumberColumn,
    MultilineNumberColumn,
    MultilineNumberNavigationColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new MultilineColumn('IMPC', 'impc').withGetProps(getConditionalProps(userType)),
        new MultilineColumn('Weekday', 'weekday').withGetProps(getConditionalProps(userType)),
        new MultilineDateColumn('Event date', 'eventDate').withGetProps(getConditionalProps(userType)).withTotalHeader('Total'),
        new MultilineNumberNavigationColumn(new NonZeroNumberColumn('Total', 'total').withGetProps(getConditionalProps(userType)).withTotalHeader(sumWithoutGroupTotal), getDetailsTabNavOptions(receptaclePodPerformanceData)),
        new MultilineNumberColumn('Registered', 'registered').withGetProps(getConditionalProps(userType)).withTotalHeader(sumWithoutGroupTotal),
        new MultilinePercentageColumn('% POD', 'podPct').withGetProps(getConditionalProps(userType)).withTotalHeader(totalRowRatio(['registered', 'total'])),
      ],
    },
  ];
};
